import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = (data) => {
  return request.put(
    'Acceptance/rewrite_on_acceptance',
    data,
    'Не удалось перезаписаться',
    'Error'
  );
};

export const useReRegistrationForAcceptance = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
